enum NodeTypeEnum {
    Dashboard,
    ObjectType
}

export default NodeTypeEnum